import axios from 'axios';
import Cookies from 'js-cookie';
import host from "../global";

export const bulkUploadService = async (formData, accessToken) => {
    return axios.post(`${host}/Bulkupload`, formData, {
        headers: {
            Authorization: `Bearer ${accessToken.toString()}`,
        },
    });
};

export const parseResumeService = async (formData, accessToken) => {
    return await axios.post(`${host}/parse_resume`, formData, {
        headers: {
            Authorization: `Bearer ${accessToken.toString()}`,
        },
    });
};

export const saveDraftCandidateService = async (draftData, accessToken) => {
    const {
        name, emailID, mobile, jobId, selectedJobPosition, jobDescription,
        resumeContent, responseScore, selectedInterviewType, interview_timelimit,
        resumeS3Url, selectedMCQSet, selectedBehavioralSet, selectedCodingSet, MCQTimeLimit, CodingTimeLimit,
        typingTimeLimit, codingJudgingCriteria,
        selectedID, responseReport, customQuestions,
    } = draftData;
    const formData = new FormData();
    formData.append("name", name);
    formData.append("candidate_email", emailID);
    formData.append("mobile", mobile);
    formData.append("job_id", jobId);
    formData.append("job_role", selectedJobPosition);
    formData.append("job_description", JSON.stringify(jobDescription));
    formData.append("resume_content", resumeContent);
    formData.append("score", responseScore);
    formData.append("interview_type", selectedInterviewType);
    formData.append("interview_timelimit", interview_timelimit);
    formData.append("resume_s3_url", resumeS3Url);
    formData.append("mcq_set_id", selectedMCQSet || "");
    formData.append("selected_behavioral_set", selectedBehavioralSet || "");
    formData.append("coding_set", selectedCodingSet);
    formData.append("mcq_time_limit", MCQTimeLimit);
    formData.append("coding_time_limit", CodingTimeLimit);
    formData.append("typing_time_limit", typingTimeLimit || 0);
    formData.append("Coding_Judge_Criteria", codingJudgingCriteria);
    formData.append("jd_id", selectedID);
    formData.append("report", JSON.stringify((({ candidate_profile, ...rest }) => rest)(responseReport)));
    formData.append("education_match", JSON.stringify(responseReport.education_match));
    formData.append("tech_tool_match", JSON.stringify(responseReport.tech_tool_match));
    formData.append("experience_match", JSON.stringify(responseReport.experience_match));
    formData.append("red_flags", JSON.stringify(responseReport.red_flags));
    formData.append("location_match", JSON.stringify(responseReport.location_match));
    formData.append("candidate_profile", JSON.stringify(responseReport.candidate_profile || {}));

    if (customQuestions?.length > 0) {
        formData.append("custom_questions", JSON.stringify(customQuestions));
    }

    return await axios.post(`${host}/save_draft_candidate`, formData, {
        headers: {
            Authorization: `Bearer ${accessToken.toString()}`,
            "Content-Type": "multipart/form-data",
        },
    });
};